import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'

// 设置公共请求路径
if (process.env.NODE_ENV === 'production') {
  axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
}


// 拦截请求，在请求头里添加token
axios.interceptors.request.use((config) => {
  let token = window.sessionStorage.getItem('token')
  let is_xiaopai = window.sessionStorage.getItem('is_xiaopai')

  if (
    is_xiaopai &&
    (window.location.href.includes('openAccount') ||
      window.location.href.includes('login'))
  ) {
    token = is_xiaopai
  }
  if (token) {
    config.headers.token = token
  }
  return config
})

// 拦截响应，判断token是否失效
axios.interceptors.response.use((response) => {
  if (response.data.code == -2 || response.data.code == -21) {
    Message.error(response.data.message)
    window.sessionStorage.removeItem('token')
    router.replace('/login')
  } else {
    return response.data
  }
})

export default axios
